import { Lock } from '@mui/icons-material';
import { Button, InputAdornment, Stack } from '@mui/material';
import type { SyntheticEvent } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACCESS_TOKEN_KEY, ID_TOKEN_KEY } from '../../../constants';
import { useTry } from '../../../hooks';
import { RestClient } from '../../../lib';
import { ContentBox } from '../../../styles/LoginContainerStyle';
import { WhiteTextField } from '../../../styles/WhiteTextFieldStyle';
import type { Success } from '../Login.type';

interface Props {
  email: string;
  session: string;
}

export function MfaVerifyForm({ email, session }: Props) {
  const navigate = useNavigate();
  const { tryReq } = useTry();
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();

    setError('');

    if (verificationCode === '' || verificationCode.length !== 6) {
      setError('認証コードは6桁の数字を入力してください');
      return;
    }

    await tryReq(
      async () => {
        const res = await RestClient.post<Success>('/mfa-challenge', {
          email,
          session,
          verificationCode,
        });

        localStorage.setItem(ID_TOKEN_KEY, res.idToken);
        localStorage.setItem(ACCESS_TOKEN_KEY, res.accessToken);

        navigate('/environment', { replace: true });
      },
      { redirectWhenAuthError: false },
    );
  };

  return (
    <ContentBox>
      <form onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <h2>MFA認証</h2>
          <p style={{ fontSize: 13 }}>
            認証アプリに表示されている6桁の認証コードを入力してください
          </p>

          <WhiteTextField
            label="認証コード"
            id="verification-code"
            name="verificationCode"
            fullWidth
            focused
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
                inputProps: { maxLength: 6 },
                inputMode: 'numeric',
              },
            }}
            value={verificationCode}
            onChange={(e) => {
              setVerificationCode(e.target.value);
            }}
            error={!!error}
            helperText={error}
          />
          <Button type="submit">送信</Button>
        </Stack>
      </form>
    </ContentBox>
  );
}
